import AcspSvgIcon from "./AcspSvgIcon";

export default {
  install(Vue, options) {
    Vue.component(AcspSvgIcon.name, AcspSvgIcon);
  },
};
